import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';
import {Einflussebene} from 'shared/dtos/cockpit-kontrolle/einfluss-von-extremwerten-m2';
import {Mitarbeiter} from 'shared/dtos/mitarbeiter';

@Component({
  selector: '[app-table-einflussextremwerten-data-row]',
  templateUrl: './table-data-row.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TableEinflussextremwertenDataRowComponent
  extends CurrentLocaleComponent
  implements OnInit
{
  @Input() rowdata: Einflussebene;
  @Input() rowHeaderKey: string;
  @Input() mitarbeiters: Mitarbeiter[];
  @Input() laufNrAusgechlossenenPers: 'Allowed' | 'None' | 'See-Above' =
    'Allowed';

  constructor(protected readonly translate: TranslateService) {
    super(translate);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
